import { DHM } from "@/common/time";
import React from "react";

type Translates = {
    for: (path: string) => string;
};

interface Props {
    dhm: DHM;
    translates: Translates;
    i18nPath?: string; // Defaults to "time", but can be overridden if needed
    classNameValue?: string;
    classNameUnit?: string;
}

export const TimeDHM: React.FC<Props> = ({
    dhm,
    translates,
    i18nPath = "time",
    classNameValue = "tdhm-value",
    classNameUnit = "tdhm-unit",
}) => {
    const parts: React.ReactNode[] = [];

    if (dhm.days) {
        parts.push(
            <span key="days">
                <span className={classNameValue}>{dhm.days}</span>
                <span className={classNameUnit}> {translates.for(`${i18nPath}.day`)}</span>
            </span>
        );
    }
    if (dhm.hours) {
        parts.push(
            <span key="hours">
                <span className={classNameValue}>{dhm.hours}</span>
                <span className={classNameUnit}> {translates.for(`${i18nPath}.hour`)}</span>
            </span>
        );
    }
    parts.push(
        <span key="minutes">
            <span className={classNameValue}>{dhm.minutes}</span>
            <span className={classNameUnit}> {translates.for(`${i18nPath}.minutes`)}</span>
        </span>
    );

    return <span>{parts.reduce((prev, curr) => [prev, " ", curr])}</span>;
};